import {
  getSpeciesRegulationsAtLocation,
  Regulations,
} from '../../../api/fishrules/getSpeciesRegulationsAtLocation';
import { ICoordinates } from '@app-types/geo';
import { useAsyncQuery } from '@hooks/useAsyncQuery';

interface Result {
  isLoading: boolean;
  regulation?: Regulations;
  fetchedAt?: string;
}

type Params = ICoordinates & { fishrulesSpeciesId: number };

export function useSpeciesRegulationAtLocation(params: Params | undefined): Result {
  const { isLoading, data } = useAsyncQuery(
    params ? `${params.latitude},${params.longitude}:${params.fishrulesSpeciesId}` : null,
    async signal => {
      const { latitude, longitude, fishrulesSpeciesId } = params!;
      return getSpeciesRegulationsAtLocation({
        latitude,
        longitude,
        species: [{ fishrulesSpeciesIds: [fishrulesSpeciesId] }],
        signal,
      });
    },
  );

  const firstResult = data?.[0];
  return { isLoading, regulation: firstResult?.regulations, fetchedAt: firstResult?.fetchedAt };
}
